import React from 'react'

import VideoCard from '../../../components/content/VideoCard'
import Slider from '../../../components/slider'
import useScreenSize from '../../../../hocs/useScreenSize'
import MobileVerticalVideoCard from '../../../components/content/MobileVerticalVideoCard'
import { Video } from '../../../../api/videos/types'
import Loading from '../../../components/layout/Loading'
import NoResults from '../../../components/layout/NoResults'

interface VideosCarouselProps {
  queryFn: () => { data: Video[] | null | undefined, isLoading: boolean, error: Error | null }
}

const VideosCarousel: React.FC<VideosCarouselProps> = ({ queryFn }) => {
  const { data, isLoading, error } = queryFn()
  const { isMd } = useScreenSize()

  if(isLoading) return <Loading />
  if(error) return <div>{error.message}</div>
  if(!data || data?.length === 0) return <NoResults />

  return (
    <Slider slidesXs={2.2} slidesLg={4.1} slidesMd={3.1}>
      {data.map((video) => (
        isMd ? (
          <VideoCard
            id={video.id}
            key={video.title}
            title={video.title}
            image={video.thumbnailsUrls.desktop}
            previewUrl={video.previewUrl}
            authors={video.authors}
            duration={video.watchTime}
            viewersCount={video.viewersCount}
            type={video.type}
            difficulty={video.difficultyLevel.name}
            category={video.mainCategory.name}
            currentPlayTime={video.userActivity?.currentPlayTime}
            watched={video.userActivity?.watched}
            bookmarked={video.userActivity?.saved}
          />
        ) : (
          <MobileVerticalVideoCard
            id={video.id}
            key={video.title}
            title={video.title}
            image={video.thumbnailsUrls.mobile}
            previewUrl={video.previewUrl}
            authors={video.authors}
            duration={video.watchTime}
            viewersCount={video.viewersCount}
            type={video.type}
            difficulty={video.difficultyLevel.name}
            category={video.mainCategory.name}
            currentPlayTime={video.userActivity?.currentPlayTime}
            watched={video.userActivity?.watched}
            bookmarked={video.userActivity?.saved}
          />
        )
      ))}
    </Slider>
  )
}

export default VideosCarousel
